export default __webpack_public_path__ + "static/goztepe-logo-e7ed2e7c72437b3149f38b53c4705a45.png";